import { useNavigate, Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";

const Home = () => {
  const navigate = useNavigate();
  const logout = useLogout();

  const signOut = async () => {
    await logout();
    navigate("/linkpage");
  };

  return (
    <section>
      <h2>Home</h2>
      <br />
      <p>You are logged in!</p>
      <br />
      <Link to="/editor">Go to the editor page</Link>
      <br />
      <Link to="/admin">Go to the admin page</Link>
      <br />
      <Link to="/lounge">Go to the lounge page</Link>
      <br />
      <Link to="/linkpage">Go to the linkpage page</Link>
      <div className="flexGrow">
        <button onClick={signOut}>Sign Out</button>
      </div>
    </section>
  );
};

export default Home;
